import { render, staticRenderFns } from "./GlofasRegistrationProfile.vue?vue&type=template&id=d1b2d940&scoped=true&"
import script from "./GlofasRegistrationProfile.vue?vue&type=script&lang=js&"
export * from "./GlofasRegistrationProfile.vue?vue&type=script&lang=js&"
import style0 from "./GlofasRegistrationProfile.vue?vue&type=style&index=0&id=d1b2d940&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b2d940",
  null
  
)

export default component.exports